const NEWBEC_DEVICE_TYPE_MAP: TStringObject = {
  phone: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
};

export function getClientDeviceType() {
  if (typeof window !== 'undefined' && window.addformDeviceType) {
    return NEWBEC_DEVICE_TYPE_MAP[window.addformDeviceType];
  }

  return 'desktop';
}
